<template>
  <a-card :bordered="false">
    <!-- table区域-begin -->
    <div>
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="false"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="selectConsumerUser(record.userid)" v-if="!!record.userid">选定为取水人</a>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>
  import { getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: 'WfSysLogList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {

    },
    props: {
      //表单禁用
      filter: {
        type: Object,
        default: () => { },
      }
    },
    watch: {
      filter: {
        handler (newVal, oldVal) {
          //只有设备ID、开始时间、结束时间变化时才重新查询
          if (newVal.devId !== oldVal.devId || newVal.createTime_begin !== oldVal.createTime_begin || newVal.createTime_end !== oldVal.createTime_end) {
            this.searchQuery();
          }
        },
        deep: true
      }
    },
    computed: {

    },
    data () {
      return {
        description: 'APP用户系统日志',
        isorter: {
          column: 'createTime',
          order: 'asc'
        },
        ipagination: {
          pageSize: 50,
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '日志内容',
            align: "left",
            dataIndex: 'logContent',
            scopedSlots: { customRender: 'logContent' },
            sorter: true
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
            align: "center",
            sorter: true
          },
          {
            title: '操作人ID',
            dataIndex: 'userid',
            align: "center",
            sorter: true
          },
          {
            title: 'IP',
            dataIndex: 'ip',
            align: "center",
            sorter: true
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 80,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/sys/log/list",
          queryWfUser: "/custom/user/list",
        },
        dictOptions: {},
        superFieldList: [],
        localFilter: {
          logType: 2, // 默认查询操作日志
          logContent: '加水记录-添加,加水结束,设备写入值,设备台账-通过任意条件获取单个设备详情', // 默认查询加水记录
        },
        disableMixinCreated: true, // 禁用混入的created生命周期
      }
    },
    created () {
      this.loadData()
    },
    computed: {

    },
    methods: {
      selectConsumerUser (username) {
        getAction(this.url.queryWfUser, { username }).then((res) => {
          if (res.success && res.result.records.length > 0) {
            this.$emit('selectConsumerUser', res.result.records[0]);
          } else {
            this.$message.error(res.message);
          }
        })
      },
      //因为查询条件重置功能会清空queryParam，所以需要重写loadData方法，把固定的查询条件加进去
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        this.dataSource = []
        var params = this.getQueryParams()// 查询条件
        this.loading = true;
        // 合并 localFilter 和 filter
        const mergedFilter = { ...this.localFilter, ...this.filter };
        Object.assign(params, mergedFilter);

        // 提取创建参数的逻辑到一个函数中
        const createParams = (params, val) => {
          let newParams = { ...params };
          if (params.devId) {
            newParams = {
              ...newParams,
              superQueryMatchType: 'and',
              superQueryParams: encodeURI(
                JSON.stringify([
                  {
                    rule: 'like',
                    type: 'string',
                    field: 'requestParam',
                    val,
                  },
                ])
              ),
            };
          }
          return newParams;
        };

        // 提取请求逻辑到一个函数中
        const fetchData = (url, params) => {
          console.log('loadData params:', params);
          return getAction(url, params).then((res) => {
            if (res.success) {
              return res.result.records;
            }
            return [];
          });
        };
        // 发起多个请求
        Promise.all([
          fetchData(this.url.list, createParams(params, `devId%${params.devId}`)),
          fetchData(this.url.list, createParams(params, `id=${params.devId}`)),
        ]).then((results) => {
          // 合并所有结果
          const allRecords = results.flat();
          // 去重处理
          const uniqueRecords = [...new Map(allRecords.map(item => [item.id, item])).values()];
          this.dataSource.push(...uniqueRecords);
        }).finally(() => {
          this.loading = false;
        });
      },
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>